module.exports = __webpack_public_path__ + "media/audio5.a2051e5f.mp3";